import EventEmitter from 'eventemitter3'
import { sentryException, sentryMessage } from '@/plugins/sentry'

const sendToSentry = (data) => {
  if (data instanceof Error) sentryException(data)
  else {
    try {
      sentryException(JSON.stringify(data))
    } catch {
      try {
        sentryMessage(data)
      } catch (e) {
        console.error(`Error capturing error in Sentry`, e)
      }
    }
  }
}

const event = new EventEmitter()

event.success = data => {
  if (typeof data == 'string') data = {type: 'success', text: data}
  event.emit('alert', data)
}
event.warning = data => {
  if (typeof data == 'string') data = {type: 'warning', text: data}
  if (data.type != 'warning') data.type = 'warning'
  event.emit('alert', data)
}
event.error = data => {
  if (typeof data == 'string') data = {type: 'error', text: data}
  else {
    sendToSentry(data)
    if (data.message || data instanceof Error) data = {type: 'error', error: data}
    else data = {type: 'error', ...data}
  }
  console.error(data)
  return event.emit('alert', data)
}
event.TRIGGER_CONFIRM_DIALOG = 'trigger_confirm_dialog'
event.TRIGGER_ACTIVATION_INSTRUCTION_DIALOG = 'trigger_activation_instruction_dialog'
event.TRIGGER_ACTIVATION_FORM = 'trigger_activation_form'

export default event
export const { success, error, warning, TRIGGER_CONFIRM_DIALOG, TRIGGER_ACTIVATION_INSTRUCTION_DIALOG, TRIGGER_ACTIVATION_FORM } = event
